module.exports = __webpack_public_path__ + "img/Electricity-PowerCable.95615a51.jpg";